module.exports = __webpack_public_path__ + "static/banner-image-5975ae5db161eccf555c760e0f5b60bc.png";